import React from "react";
import {
  Box, Grid, Typography, Card, CardContent, CardActionArea, Chip,
} from "@mui/material";
import {
  MoneyOff, AccountBalance, CheckCircle, Campaign,
} from "@mui/icons-material";

const PROJECT_TYPES = [
  {
    value: "no-cost",
    label: "No Cost",
    description: "This project has no financial impact — track progress only",
    icon: MoneyOff,
    color: "#2e7d32",
    gradient: "linear-gradient(135deg, #43a047 0%, #2e7d32 100%)",
  },
  {
    value: "corpus",
    label: "Fund from Corpus",
    description:
      "Use existing corpus / reserve funds — no separate collection from members needed",
    icon: AccountBalance,
    color: "#6a1b9a",
    gradient: "linear-gradient(135deg, #7b1fa2 0%, #6a1b9a 100%)",
  },
  {
    value: "fund-raise",
    label: "Fund Raise",
    description:
      "Raise funds from members — configure settlement, generate dues, and collect payments",
    icon: Campaign,
    color: "#e65100",
    gradient: "linear-gradient(135deg, #ef6c00 0%, #e65100 100%)",
  },
];

const Classify = ({ hfControl, control, watch, setValue }) => {
  const projectType = watch("projectType");

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography variant="h6" fontWeight={600}>
          Classify this Project
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        What is the financial nature of this project? You can always change
        this later.
      </Typography>

      <Grid container spacing={2}>
        {PROJECT_TYPES.map((type) => {
          const Icon = type.icon;
          const selected = projectType === type.value;
          return (
            <Grid item xs={12} sm={4} key={type.value}>
              <Card
                elevation={selected ? 6 : 1}
                sx={{
                  border: selected
                    ? `2px solid ${type.color}`
                    : "2px solid transparent",
                  borderRadius: 3,
                  transition: "all 0.25s",
                  transform: selected ? "scale(1.02)" : "none",
                }}
              >
                <CardActionArea
                  onClick={() => setValue("projectType", type.value)}
                  sx={{ p: 0 }}
                >
                  <Box
                    sx={{
                      background: type.gradient,
                      color: "white",
                      p: 2,
                      textAlign: "center",
                    }}
                  >
                    <Icon sx={{ fontSize: 40 }} />
                    {selected && (
                      <CheckCircle
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          fontSize: 22,
                        }}
                      />
                    )}
                  </Box>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="subtitle1" fontWeight={700}>
                      {type.label}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 0.5, fontSize: "0.8rem", minHeight: 48 }}
                    >
                      {type.description}
                    </Typography>
                    {selected && (
                      <Chip
                        label="Selected"
                        size="small"
                        sx={{
                          mt: 1,
                          bgcolor: type.color,
                          color: "white",
                          fontWeight: 600,
                        }}
                      />
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Classify;
